import http from 'utils/http';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getAgencyAssociatedRecordsUrl, getAgencyCallLogUrl, getAgencyCallLogsUrl } from './apiUrls';
import { AgencyCallLogResponse, AssociatedRecordResponse } from './types';

export function getAgencyCallLogs(
  params?: Record<string, any>
): Promise<{ data: AgencyCallLogResponse[]; meta: MetaApiResponse }> {
  return http.get(getAgencyCallLogsUrl(), params);
}

export function getAgencyCallLog(id: string, params?: Record<string, any>): Promise<AgencyCallLogResponse> {
  return http.get(getAgencyCallLogUrl(Number(id)), params);
}

export function getAgencyAssociatedRecords(
  interactionId: number,
  contactId: number,
  params?: Record<string, any>
): Promise<{ integration_entity_contacts: AssociatedRecordResponse[]; meta: MetaApiResponse }> {
  return http.get(getAgencyAssociatedRecordsUrl(interactionId, contactId), params);
}
